import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';




function AllCurrency(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    
    const [allcurrency, setAllCurrency] = useState([]);

    axios.defaults.withCredentials = true;





    const GetAllCurrency = ()=>{
        axios.post('AllItems', {
            table: 'currency',
        })
        .then((res) => {
            if (res.data) {
                setAllCurrency(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    




    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }






useEffect(() => {

    GetAllCurrency();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th> الاسم  </th>

                            <th>الخيارات</th>

                        </tr>
                    </thead>
                    <tbody>
                    {allcurrency.length ? (

                    allcurrency.map(currency => {

                        return (
                            <tr key={currency.id}>
                            <td><h6>{currency.id}</h6></td>



                            <td><h2>{currency.name}</h2></td>

                            <td>
                                <Link className='edit' to={`/edit-currency?id=${currency.id}`}> <i class="las la-edit"></i> </Link>
                            </td>


                            </tr>
                        );
                        })): 
                        
                        
                        
                        (
                            <tr>
                                <td colSpan={5}>تحميل...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllCurrency;